module.exports = __webpack_public_path__ + "static/media/my_card_icon.00334576.svg";